<template>
    <div id="Om-Mig" class="bg-om-mig p-5 z-depth-1 scrollspy-example" data-spy="scroll" data-offset="0">
        <section class="container white-text mb-4">
            <h1 class="text-center mb-3 pt-3 wow heartBeat" data-wow-duration="2s">Vem är jag?</h1>
            <hr class="my-hr-color my-hr-size mb-5">
            <div class="row pt-2">
                <div class="col-lg-5 text-center mt-2 mb-4">
                    <img class="img-fluid me-img" src="@/assets/pb.jpg" alt="Image of Fredrik">
                    <div class="row text-left img-text mt-4">
                        <div class="col-10 offset-1 col-lg-8 offset-lg-2 div-wrapper d-flex justify-content-center align-items-center">
                            <div>
                                <div class="mb-1 d-flex">
                                    <i class="fas fa-envelope fa-lg my-color mx-3 pt-2"></i>             
                                    <a class="white-text my-hover-effect" href="mailto:fredrikg@nomea.se">fredrikg@nomea.se</a> 
                                </div>
                                <div class="mb-1">
                                    <i class="fas fa-phone fa-lg my-color mx-3"></i>
                                    <a class="white-text my-hover-effect" href="tel:0727372767">072 737 27 67</a>
                                </div>
                                <div class="mb-1">
                                    <i class="fab fa-instagram fa-lg my-color mx-3"></i>
                                    <a class="white-text my-hover-effect" href="https://www.instagram.com/freddegehrke/" target="_blank">Instagram</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="row mb-3">
                        <div class="col-1">
                            <i class="fas fa-user fa-lg my-color"></i>
                        </div>
                        <div class="col-xl-10 col-md-11 col-10">
                            <h5 class="font-weight-bold mb-3 my-color">Fredrik Gehrke</h5>
                            <p class="">Jag heter Fredrik, är 22 år och bosatt i Västerås. Webbdesign, programmering och marknadsföring 
                                är något som jag tycker är otroligt intressant och roligt att hålla på med.
                            </p>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-1">
                            <i class="fas fa-graduation-cap fa-lg my-color"></i>
                        </div>
                        <div class="col-xl-10 col-md-11 col-10">
                            <h5 class="font-weight-bold mb-3 my-color">Utbildning</h5>
                            <p class="">Jag tog examen i Ekonomi marknadsföring på Thoren Business School i Västerås 2018.
                                <br>Hösten 2019 startade min utbildning på EC Utbildning i Västerås till att bli Frontend-utvecklare. <br> Tog sedan examen våren 2021. 
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-1">
                            <i class="fas fa-bullseye fa-lg my-color"></i>
                        </div>
                        <div class="col-xl-10 col-md-11 col-10">
                            <h5 class="font-weight-bold mb-3 my-color">Mina Mål</h5>
                            <p class="mb-0">Nu efter avklarad utbildning arbetar jag som konsult men i 
                                framtiden vill jag börja jobba på ett företag som håller på med just webbdesign, programmering, marknadsföring med mera. 
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>


p {
    font-size: 18px;
}

.my-hover-effect:hover {
    color: var(--my-color) !important; 
}

.img-text {
    font-size: 20px;
}

.me-img {
    width: 70%;
    max-width: 70%;
    height: auto;
    border-radius: 20px;
    box-shadow: 0px 5px 20px 10px rgba(136, 136, 136, 0.288);  
}

.bg-om-mig {
    background: linear-gradient(to bottom, rgba(21, 26, 36, 0.966), rgb(28, 35, 49));
}


@media(max-width: 992px) { 
    .me-img {
        width: 45%;
    }
}

</style>